import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { GetAccountInfoQuery } from '@websky/graphql';
import { useTheme } from '../../theme';
import ServicesGroup from './ServicesGroup/ServicesGroup';
import { ServiceGroupType } from '../types';
import ServicesAggregationProvider from '../context';

interface Props {
	serviceGroups: ServiceGroupType[];
	userInfo?: GetAccountInfoQuery['CurrentUser'];
	refetchUser?: () => Promise<GetAccountInfoQuery>;
}

const ServiceAggregation: React.FC<Props> = ({ serviceGroups, userInfo, refetchUser }) => {
	const theme = useTheme('ServiceAggregation').ServiceAggregation;

	const { t } = useTranslation('ServiceAggregation');

	return (
		<ServicesAggregationProvider userInfo={userInfo} refetchUser={refetchUser}>
			<div className={theme.container}>
				<div className={theme.header}>{t('Plan your trip')}</div>

				<div>
					{serviceGroups.map(group => {
						return (
							<ServicesGroup
								key={group.type}
								icon={group.icon}
								directionLabel={group.directionLabel}
								timePeriod={group.timePeriod}
								className={theme.group}
								description={group.description}
								empty={group.empty}
							>
								{group.services}
							</ServicesGroup>
						);
					})}
				</div>
			</div>
		</ServicesAggregationProvider>
	);
};

export default ServiceAggregation;
